module.exports = __webpack_public_path__ + "static/media/WSG.5772e72e.svg";